const bankAccountBalanceScores = [
    { min: 0, max: 27, jobIndex: 0, minPrice: 0, maxPrice: 204000000, score: 1 },
    { min: 27, max: 40, jobIndex: 0, minPrice: 0, maxPrice: 204000000, score: -2 },
    { min: 40, max: 55, jobIndex: 0, minPrice: 0, maxPrice: 204000000, score: -4 },
    { min: 55, max: 200, jobIndex: 0, minPrice: 0, maxPrice: 204000000, score: -6 },

    { min: 0, max: 27, jobIndex: 0, minPrice: 204000000, maxPrice: 800000000, score: 5 },
    { min: 27, max: 40, jobIndex: 0, minPrice: 204000000, maxPrice: 800000000, score: -1 },
    { min: 40, max: 55, jobIndex: 0, minPrice: 204000000, maxPrice: 800000000, score: -2 },
    { min: 55, max: 200, jobIndex: 0, minPrice: 204000000, maxPrice: 800000000, score: -4 },

    { min: 0, max: 27, jobIndex: 0, minPrice: 800000000, maxPrice: 1150000000, score: 6 },
    { min: 27, max: 40, jobIndex: 0, minPrice: 800000000, maxPrice: 1150000000, score: 2 },
    { min: 40, max: 55, jobIndex: 0, minPrice: 800000000, maxPrice: 1150000000, score: 1 },
    { min: 55, max: 200, jobIndex: 0, minPrice: 800000000, maxPrice: 1150000000, score: -2 },

    { min: 0, max: 27, jobIndex: 0, minPrice: 1150000000, maxPrice: 1500220000, score: 6 },
    { min: 27, max: 40, jobIndex: 0, minPrice: 1150000000, maxPrice: 1500220000, score: 2 },
    { min: 40, max: 55, jobIndex: 0, minPrice: 1150000000, maxPrice: 1500220000, score: 2 },
    { min: 55, max: 200, jobIndex: 0, minPrice: 1150000000, maxPrice: 1500220000, score: 0 },

    { min: 0, max: 27, jobIndex: 0, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },
    { min: 27, max: 40, jobIndex: 0, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },
    { min: 40, max: 55, jobIndex: 0, minPrice: 1500220000, maxPrice: 2200300000, score: 2 },
    { min: 55, max: 200, jobIndex: 0, minPrice: 1500220000, maxPrice: 2200300000, score: 1 },

    { min: 0, max: 27, jobIndex: 0, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 27, max: 40, jobIndex: 0, minPrice: 2200300000, maxPrice: 3000400000, score: 5 },
    { min: 40, max: 55, jobIndex: 0, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 55, max: 200, jobIndex: 0, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },

    { min: 0, max: 27, jobIndex: 0, minPrice: 3000400000, maxPrice: 4000500000, score: 2 },
    { min: 27, max: 40, jobIndex: 0, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 40, max: 55, jobIndex: 0, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 55, max: 200, jobIndex: 0, minPrice: 3000400000, maxPrice: 4000500000, score: 3 },

    { min: 0, max: 27, jobIndex: 0, minPrice: 4000500000, maxPrice: 5000700000, score: 1 },
    { min: 27, max: 40, jobIndex: 0, minPrice: 4000500000, maxPrice: 5000700000, score: 3 },
    { min: 40, max: 55, jobIndex: 0, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 55, max: 200, jobIndex: 0, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },

    { min: 0, max: 27, jobIndex: 0, minPrice: 5000700000, maxPrice: 10000000000, score: -2 },
    { min: 27, max: 40, jobIndex: 0, minPrice: 5000700000, maxPrice: 10000000000, score: 2 },
    { min: 40, max: 55, jobIndex: 0, minPrice: 5000700000, maxPrice: 10000000000, score: 3 },
    { min: 55, max: 200, jobIndex: 0, minPrice: 5000700000, maxPrice: 10000000000, score: 4 },

    // Worker man
    { min: 0, max: 27, jobIndex: 1, minPrice: 0, maxPrice: 204000000, score: -5 },
    { min: 27, max: 40, jobIndex: 1, minPrice: 0, maxPrice: 204000000, score: -7 },
    { min: 40, max: 55, jobIndex: 1, minPrice: 0, maxPrice: 204000000, score: -8 },
    { min: 55, max: 200, jobIndex: 1, minPrice: 0, maxPrice: 204000000, score: -10 },

    { min: 0, max: 27, jobIndex: 1, minPrice: 204000000, maxPrice: 800000000, score: 0 },
    { min: 27, max: 40, jobIndex: 1, minPrice: 204000000, maxPrice: 800000000, score: -2 },
    { min: 40, max: 55, jobIndex: 1, minPrice: 204000000, maxPrice: 800000000, score: -4 },
    { min: 55, max: 200, jobIndex: 1, minPrice: 204000000, maxPrice: 800000000, score: -5 },

    { min: 0, max: 27, jobIndex: 1, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 27, max: 40, jobIndex: 1, minPrice: 800000000, maxPrice: 1150000000, score: -1 },
    { min: 40, max: 55, jobIndex: 1, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 55, max: 200, jobIndex: 1, minPrice: 800000000, maxPrice: 1150000000, score: -4 },

    { min: 0, max: 27, jobIndex: 1, minPrice: 1150000000, maxPrice: 1500220000, score: 3 },
    { min: 27, max: 40, jobIndex: 1, minPrice: 1150000000, maxPrice: 1500220000, score: 0 },
    { min: 40, max: 55, jobIndex: 1, minPrice: 1150000000, maxPrice: 1500220000, score: -2 },
    { min: 55, max: 200, jobIndex: 1, minPrice: 1150000000, maxPrice: 1500220000, score: -3 },

    { min: 0, max: 27, jobIndex: 1, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },
    { min: 27, max: 40, jobIndex: 1, minPrice: 1500220000, maxPrice: 2200300000, score: 0 },
    { min: 40, max: 55, jobIndex: 1, minPrice: 1500220000, maxPrice: 2200300000, score: 0 },
    { min: 55, max: 200, jobIndex: 1, minPrice: 1500220000, maxPrice: 2200300000, score: -1 },

    { min: 0, max: 27, jobIndex: 1, minPrice: 2200300000, maxPrice: 3000400000, score: 4 },
    { min: 27, max: 40, jobIndex: 1, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 40, max: 55, jobIndex: 1, minPrice: 2200300000, maxPrice: 3000400000, score: 0 },
    { min: 55, max: 200, jobIndex: 1, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },

    { min: 0, max: 27, jobIndex: 1, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 27, max: 40, jobIndex: 1, minPrice: 3000400000, maxPrice: 4000500000, score: 3 },
    { min: 40, max: 55, jobIndex: 1, minPrice: 3000400000, maxPrice: 4000500000, score: 4 },
    { min: 55, max: 200, jobIndex: 1, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },

    { min: 0, max: 27, jobIndex: 1, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 27, max: 40, jobIndex: 1, minPrice: 4000500000, maxPrice: 5000700000, score: 4 },
    { min: 40, max: 55, jobIndex: 1, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 55, max: 200, jobIndex: 1, minPrice: 4000500000, maxPrice: 5000700000, score: 6 },

    { min: 0, max: 27, jobIndex: 1, minPrice: 5000700000, maxPrice: 10000000000, score: 0 },
    { min: 27, max: 40, jobIndex: 1, minPrice: 5000700000, maxPrice: 10000000000, score: 1 },
    { min: 40, max: 55, jobIndex: 1, minPrice: 5000700000, maxPrice: 10000000000, score: 5 },
    { min: 55, max: 200, jobIndex: 1, minPrice: 5000700000, maxPrice: 10000000000, score: 8 },

    // Doctor
    { min: 0, max: 27, jobIndex: 2, minPrice: 0, maxPrice: 204000000, score: 0 },
    { min: 27, max: 40, jobIndex: 2, minPrice: 0, maxPrice: 204000000, score: -2 },
    { min: 40, max: 55, jobIndex: 2, minPrice: 0, maxPrice: 204000000, score: -5 },
    { min: 55, max: 200, jobIndex: 2, minPrice: 0, maxPrice: 204000000, score: -8 },

    { min: 0, max: 27, jobIndex: 2, minPrice: 204000000, maxPrice: 800000000, score: 3 },
    { min: 27, max: 40, jobIndex: 2, minPrice: 204000000, maxPrice: 800000000, score: 0 },
    { min: 40, max: 55, jobIndex: 2, minPrice: 204000000, maxPrice: 800000000, score: -1 },
    { min: 55, max: 200, jobIndex: 2, minPrice: 204000000, maxPrice: 800000000, score: -6 },

    { min: 0, max: 27, jobIndex: 2, minPrice: 800000000, maxPrice: 1150000000, score: 4 },
    { min: 27, max: 40, jobIndex: 2, minPrice: 800000000, maxPrice: 1150000000, score: 1 },
    { min: 40, max: 55, jobIndex: 2, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 55, max: 200, jobIndex: 2, minPrice: 800000000, maxPrice: 1150000000, score: -2 },

    { min: 0, max: 27, jobIndex: 2, minPrice: 1150000000, maxPrice: 1500220000, score: 4 },
    { min: 27, max: 40, jobIndex: 2, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 40, max: 55, jobIndex: 2, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 55, max: 200, jobIndex: 2, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },

    { min: 0, max: 27, jobIndex: 2, minPrice: 1500220000, maxPrice: 2200300000, score: 5 },
    { min: 27, max: 40, jobIndex: 2, minPrice: 1500220000, maxPrice: 2200300000, score: 5 },
    { min: 40, max: 55, jobIndex: 2, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },
    { min: 55, max: 200, jobIndex: 2, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },

    { min: 0, max: 27, jobIndex: 2, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 27, max: 40, jobIndex: 2, minPrice: 2200300000, maxPrice: 3000400000, score: 6 },
    { min: 40, max: 55, jobIndex: 2, minPrice: 2200300000, maxPrice: 3000400000, score: 4 },
    { min: 55, max: 200, jobIndex: 2, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },

    { min: 0, max: 27, jobIndex: 2, minPrice: 3000400000, maxPrice: 4000500000, score: 3 },
    { min: 27, max: 40, jobIndex: 2, minPrice: 3000400000, maxPrice: 4000500000, score: 7 },
    { min: 40, max: 55, jobIndex: 2, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 55, max: 200, jobIndex: 2, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },

    { min: 0, max: 27, jobIndex: 2, minPrice: 4000500000, maxPrice: 5000700000, score: 1 },
    { min: 27, max: 40, jobIndex: 2, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 40, max: 55, jobIndex: 2, minPrice: 4000500000, maxPrice: 5000700000, score: 7 },
    { min: 55, max: 200, jobIndex: 2, minPrice: 4000500000, maxPrice: 5000700000, score: 7 },

    { min: 0, max: 27, jobIndex: 2, minPrice: 5000700000, maxPrice: 10000000000, score: -2 },
    { min: 27, max: 40, jobIndex: 2, minPrice: 5000700000, maxPrice: 10000000000, score: 4 },
    { min: 40, max: 55, jobIndex: 2, minPrice: 5000700000, maxPrice: 10000000000, score: 9 },
    { min: 55, max: 200, jobIndex: 2, minPrice: 5000700000, maxPrice: 10000000000, score: 10 },

    // Doctor
    { min: 0, max: 27, jobIndex: 3, minPrice: 0, maxPrice: 204000000, score: 0 },
    { min: 27, max: 40, jobIndex: 3, minPrice: 0, maxPrice: 204000000, score: -2 },
    { min: 40, max: 55, jobIndex: 3, minPrice: 0, maxPrice: 204000000, score: -5 },
    { min: 55, max: 200, jobIndex: 3, minPrice: 0, maxPrice: 204000000, score: -8 },

    { min: 0, max: 27, jobIndex: 3, minPrice: 204000000, maxPrice: 800000000, score: 3 },
    { min: 27, max: 40, jobIndex: 3, minPrice: 204000000, maxPrice: 800000000, score: 0 },
    { min: 40, max: 55, jobIndex: 3, minPrice: 204000000, maxPrice: 800000000, score: -1 },
    { min: 55, max: 200, jobIndex: 3, minPrice: 204000000, maxPrice: 800000000, score: -6 },

    { min: 0, max: 27, jobIndex: 3, minPrice: 800000000, maxPrice: 1150000000, score: 4 },
    { min: 27, max: 40, jobIndex: 3, minPrice: 800000000, maxPrice: 1150000000, score: 1 },
    { min: 40, max: 55, jobIndex: 3, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 55, max: 200, jobIndex: 3, minPrice: 800000000, maxPrice: 1150000000, score: -2 },

    { min: 0, max: 27, jobIndex: 3, minPrice: 1150000000, maxPrice: 1500220000, score: 4 },
    { min: 27, max: 40, jobIndex: 3, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 40, max: 55, jobIndex: 3, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 55, max: 200, jobIndex: 3, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },

    { min: 0, max: 27, jobIndex: 3, minPrice: 1500220000, maxPrice: 2200300000, score: 5 },
    { min: 27, max: 40, jobIndex: 3, minPrice: 1500220000, maxPrice: 2200300000, score: 5 },
    { min: 40, max: 55, jobIndex: 3, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },
    { min: 55, max: 200, jobIndex: 3, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },

    { min: 0, max: 27, jobIndex: 3, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 27, max: 40, jobIndex: 3, minPrice: 2200300000, maxPrice: 3000400000, score: 6 },
    { min: 40, max: 55, jobIndex: 3, minPrice: 2200300000, maxPrice: 3000400000, score: 4 },
    { min: 55, max: 200, jobIndex: 3, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },

    { min: 0, max: 27, jobIndex: 3, minPrice: 3000400000, maxPrice: 4000500000, score: 3 },
    { min: 27, max: 40, jobIndex: 3, minPrice: 3000400000, maxPrice: 4000500000, score: 7 },
    { min: 40, max: 55, jobIndex: 3, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 55, max: 200, jobIndex: 3, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },

    { min: 0, max: 27, jobIndex: 3, minPrice: 4000500000, maxPrice: 5000700000, score: 1 },
    { min: 27, max: 40, jobIndex: 3, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 40, max: 55, jobIndex: 3, minPrice: 4000500000, maxPrice: 5000700000, score: 7 },
    { min: 55, max: 200, jobIndex: 3, minPrice: 4000500000, maxPrice: 5000700000, score: 7 },

    { min: 0, max: 27, jobIndex: 3, minPrice: 5000700000, maxPrice: 10000000000, score: -2 },
    { min: 27, max: 40, jobIndex: 3, minPrice: 5000700000, maxPrice: 10000000000, score: 4 },
    { min: 40, max: 55, jobIndex: 3, minPrice: 5000700000, maxPrice: 10000000000, score: 9 },
    { min: 55, max: 200, jobIndex: 3, minPrice: 5000700000, maxPrice: 10000000000, score: 10 },

    // Creator
    { min: 0, max: 27, jobIndex: 4, minPrice: 0, maxPrice: 204000000, score: -5 },
    { min: 27, max: 40, jobIndex: 4, minPrice: 0, maxPrice: 204000000, score: -7 },
    { min: 40, max: 55, jobIndex: 4, minPrice: 0, maxPrice: 204000000, score: -7 },
    { min: 55, max: 200, jobIndex: 4, minPrice: 0, maxPrice: 204000000, score: -7 },

    { min: 0, max: 27, jobIndex: 4, minPrice: 204000000, maxPrice: 800000000, score: -5 },
    { min: 27, max: 40, jobIndex: 4, minPrice: 204000000, maxPrice: 800000000, score: -5 },
    { min: 40, max: 55, jobIndex: 4, minPrice: 204000000, maxPrice: 800000000, score: -6 },
    { min: 55, max: 200, jobIndex: 4, minPrice: 204000000, maxPrice: 800000000, score: -6 },

    { min: 0, max: 27, jobIndex: 4, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 27, max: 40, jobIndex: 4, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 40, max: 55, jobIndex: 4, minPrice: 800000000, maxPrice: 1150000000, score: -3 },
    { min: 55, max: 200, jobIndex: 4, minPrice: 800000000, maxPrice: 1150000000, score: -3 },

    { min: 0, max: 27, jobIndex: 4, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 27, max: 40, jobIndex: 4, minPrice: 1150000000, maxPrice: 1500220000, score: 0 },
    { min: 40, max: 55, jobIndex: 4, minPrice: 1150000000, maxPrice: 1500220000, score: -1 },
    { min: 55, max: 200, jobIndex: 4, minPrice: 1150000000, maxPrice: 1500220000, score: -1 },

    { min: 0, max: 27, jobIndex: 4, minPrice: 1500220000, maxPrice: 2200300000, score: 2 },
    { min: 27, max: 40, jobIndex: 4, minPrice: 1500220000, maxPrice: 2200300000, score: 1 },
    { min: 40, max: 55, jobIndex: 4, minPrice: 1500220000, maxPrice: 2200300000, score: 0 },
    { min: 55, max: 200, jobIndex: 4, minPrice: 1500220000, maxPrice: 2200300000, score: -1 },

    { min: 0, max: 27, jobIndex: 4, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 27, max: 40, jobIndex: 4, minPrice: 2200300000, maxPrice: 3000400000, score: 1 },
    { min: 40, max: 55, jobIndex: 4, minPrice: 2200300000, maxPrice: 3000400000, score: 1 },
    { min: 55, max: 200, jobIndex: 4, minPrice: 2200300000, maxPrice: 3000400000, score: -1 },

    { min: 0, max: 27, jobIndex: 4, minPrice: 3000400000, maxPrice: 4000500000, score: 4 },
    { min: 27, max: 40, jobIndex: 4, minPrice: 3000400000, maxPrice: 4000500000, score: 2 },
    { min: 40, max: 55, jobIndex: 4, minPrice: 3000400000, maxPrice: 4000500000, score: 1 },
    { min: 55, max: 200, jobIndex: 4, minPrice: 3000400000, maxPrice: 4000500000, score: 2 },

    { min: 0, max: 27, jobIndex: 4, minPrice: 4000500000, maxPrice: 5000700000, score: 4 },
    { min: 27, max: 40, jobIndex: 4, minPrice: 4000500000, maxPrice: 5000700000, score: 4 },
    { min: 40, max: 55, jobIndex: 4, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 55, max: 200, jobIndex: 4, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },

    { min: 0, max: 27, jobIndex: 4, minPrice: 5000700000, maxPrice: 10000000000, score: 7 },
    { min: 27, max: 40, jobIndex: 4, minPrice: 5000700000, maxPrice: 10000000000, score: 7 },
    { min: 40, max: 55, jobIndex: 4, minPrice: 5000700000, maxPrice: 10000000000, score: 7 },
    { min: 55, max: 200, jobIndex: 4, minPrice: 5000700000, maxPrice: 10000000000, score: 8 },

    // One lic
    { min: 0, max: 27, jobIndex: 5, minPrice: 0, maxPrice: 204000000, score: -2 },
    { min: 27, max: 40, jobIndex: 5, minPrice: 0, maxPrice: 204000000, score: -3 },
    { min: 40, max: 55, jobIndex: 5, minPrice: 0, maxPrice: 204000000, score: -3 },
    { min: 55, max: 200, jobIndex: 5, minPrice: 0, maxPrice: 204000000, score: -3 },

    { min: 0, max: 27, jobIndex: 5, minPrice: 204000000, maxPrice: 800000000, score: -1 },
    { min: 27, max: 40, jobIndex: 5, minPrice: 204000000, maxPrice: 800000000, score: -3 },
    { min: 40, max: 55, jobIndex: 5, minPrice: 204000000, maxPrice: 800000000, score: -3 },
    { min: 55, max: 200, jobIndex: 5, minPrice: 204000000, maxPrice: 800000000, score: -3 },

    { min: 0, max: 27, jobIndex: 5, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 27, max: 40, jobIndex: 5, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 40, max: 55, jobIndex: 5, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 55, max: 200, jobIndex: 5, minPrice: 800000000, maxPrice: 1150000000, score: -2 },

    { min: 0, max: 27, jobIndex: 5, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 27, max: 40, jobIndex: 5, minPrice: 1150000000, maxPrice: 1500220000, score: 0 },
    { min: 40, max: 55, jobIndex: 5, minPrice: 1150000000, maxPrice: 1500220000, score: -1 },
    { min: 55, max: 200, jobIndex: 5, minPrice: 1150000000, maxPrice: 1500220000, score: -2 },

    { min: 0, max: 27, jobIndex: 5, minPrice: 1500220000, maxPrice: 2200300000, score: 2 },
    { min: 27, max: 40, jobIndex: 5, minPrice: 1500220000, maxPrice: 2200300000, score: 0 },
    { min: 40, max: 55, jobIndex: 5, minPrice: 1500220000, maxPrice: 2200300000, score: -1 },
    { min: 55, max: 200, jobIndex: 5, minPrice: 1500220000, maxPrice: 2200300000, score: -2 },

    { min: 0, max: 27, jobIndex: 5, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 27, max: 40, jobIndex: 5, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },
    { min: 40, max: 55, jobIndex: 5, minPrice: 2200300000, maxPrice: 3000400000, score: 1 },
    { min: 55, max: 200, jobIndex: 5, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },

    { min: 0, max: 27, jobIndex: 5, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 27, max: 40, jobIndex: 5, minPrice: 3000400000, maxPrice: 4000500000, score: 4 },
    { min: 40, max: 55, jobIndex: 5, minPrice: 3000400000, maxPrice: 4000500000, score: 3 },
    { min: 55, max: 200, jobIndex: 5, minPrice: 3000400000, maxPrice: 4000500000, score: 2 },

    { min: 0, max: 27, jobIndex: 5, minPrice: 4000500000, maxPrice: 5000700000, score: 6 },
    { min: 27, max: 40, jobIndex: 5, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 40, max: 55, jobIndex: 5, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 55, max: 200, jobIndex: 5, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },

    { min: 0, max: 27, jobIndex: 5, minPrice: 5000700000, maxPrice: 10000000000, score: 6 },
    { min: 27, max: 40, jobIndex: 5, minPrice: 5000700000, maxPrice: 10000000000, score: 6 },
    { min: 40, max: 55, jobIndex: 5, minPrice: 5000700000, maxPrice: 10000000000, score: 9 },
    { min: 55, max: 200, jobIndex: 5, minPrice: 5000700000, maxPrice: 10000000000, score: 10 },

    // Retire
    { min: 55, max: 200, jobIndex: 6, minPrice: 0, maxPrice: 204000000, score: -6 },
    { min: 55, max: 200, jobIndex: 6, minPrice: 204000000, maxPrice: 800000000, score: -4 },
    { min: 55, max: 200, jobIndex: 6, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 55, max: 200, jobIndex: 6, minPrice: 1150000000, maxPrice: 1500220000, score: 0 },
    { min: 55, max: 200, jobIndex: 6, minPrice: 1500220000, maxPrice: 2200300000, score: 1 },
    { min: 55, max: 200, jobIndex: 6, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },
    { min: 55, max: 200, jobIndex: 6, minPrice: 3000400000, maxPrice: 4000500000, score: 3 },
    { min: 55, max: 200, jobIndex: 6, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 55, max: 200, jobIndex: 6, minPrice: 5000700000, maxPrice: 10000000000, score: 4 },


    // No job
    { min: 0, max: 27, jobIndex: 7, minPrice: 0, maxPrice: 204000000, score: -5 },
    { min: 27, max: 40, jobIndex: 7, minPrice: 0, maxPrice: 204000000, score: -7 },
    { min: 40, max: 55, jobIndex: 7, minPrice: 0, maxPrice: 204000000, score: -8 },
    { min: 55, max: 200, jobIndex: 7, minPrice: 0, maxPrice: 204000000, score: -10 },

    { min: 0, max: 27, jobIndex: 7, minPrice: 204000000, maxPrice: 800000000, score: 0 },
    { min: 27, max: 40, jobIndex: 7, minPrice: 204000000, maxPrice: 800000000, score: -2 },
    { min: 40, max: 55, jobIndex: 7, minPrice: 204000000, maxPrice: 800000000, score: -4 },
    { min: 55, max: 200, jobIndex: 7, minPrice: 204000000, maxPrice: 800000000, score: -5 },

    { min: 0, max: 27, jobIndex: 7, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 27, max: 40, jobIndex: 7, minPrice: 800000000, maxPrice: 1150000000, score: -1 },
    { min: 40, max: 55, jobIndex: 7, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 55, max: 200, jobIndex: 7, minPrice: 800000000, maxPrice: 1150000000, score: -4 },

    { min: 0, max: 27, jobIndex: 7, minPrice: 1150000000, maxPrice: 1500220000, score: 3 },
    { min: 27, max: 40, jobIndex: 7, minPrice: 1150000000, maxPrice: 1500220000, score: 0 },
    { min: 40, max: 55, jobIndex: 7, minPrice: 1150000000, maxPrice: 1500220000, score: -2 },
    { min: 55, max: 200, jobIndex: 7, minPrice: 1150000000, maxPrice: 1500220000, score: -3 },

    { min: 0, max: 27, jobIndex: 7, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },
    { min: 27, max: 40, jobIndex: 7, minPrice: 1500220000, maxPrice: 2200300000, score: 0 },
    { min: 40, max: 55, jobIndex: 7, minPrice: 1500220000, maxPrice: 2200300000, score: 0 },
    { min: 55, max: 200, jobIndex: 7, minPrice: 1500220000, maxPrice: 2200300000, score: -1 },

    { min: 0, max: 27, jobIndex: 7, minPrice: 2200300000, maxPrice: 3000400000, score: 4 },
    { min: 27, max: 40, jobIndex: 7, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 40, max: 55, jobIndex: 7, minPrice: 2200300000, maxPrice: 3000400000, score: 0 },
    { min: 55, max: 200, jobIndex: 7, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },

    { min: 0, max: 27, jobIndex: 7, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 27, max: 40, jobIndex: 7, minPrice: 3000400000, maxPrice: 4000500000, score: 3 },
    { min: 40, max: 55, jobIndex: 7, minPrice: 3000400000, maxPrice: 4000500000, score: 4 },
    { min: 55, max: 200, jobIndex: 7, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },

    { min: 0, max: 27, jobIndex: 7, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 27, max: 40, jobIndex: 7, minPrice: 4000500000, maxPrice: 5000700000, score: 4 },
    { min: 40, max: 55, jobIndex: 7, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 55, max: 200, jobIndex: 7, minPrice: 4000500000, maxPrice: 5000700000, score: 6 },

    { min: 0, max: 27, jobIndex: 7, minPrice: 5000700000, maxPrice: 10000000000, score: 0 },
    { min: 27, max: 40, jobIndex: 7, minPrice: 5000700000, maxPrice: 10000000000, score: 1 },
    { min: 40, max: 55, jobIndex: 7, minPrice: 5000700000, maxPrice: 10000000000, score: 5 },
    { min: 55, max: 200, jobIndex: 7, minPrice: 5000700000, maxPrice: 10000000000, score: 8 },

    // Student
    { min: 0, max: 27, jobIndex: 8, minPrice: 0, maxPrice: 204000000, score: -5 },
    { min: 0, max: 27, jobIndex: 8, minPrice: 204000000, maxPrice: 800000000, score: 0 },
    { min: 0, max: 27, jobIndex: 8, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 0, max: 27, jobIndex: 8, minPrice: 1150000000, maxPrice: 1500220000, score: 3 },
    { min: 0, max: 27, jobIndex: 8, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },
    { min: 0, max: 27, jobIndex: 8, minPrice: 2200300000, maxPrice: 3000400000, score: 4 },
    { min: 0, max: 27, jobIndex: 8, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 0, max: 27, jobIndex: 8, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 0, max: 27, jobIndex: 8, minPrice: 5000700000, maxPrice: 10000000000, score: 0 },


    // Loyyer
    { min: 0, max: 27, jobIndex: 9, minPrice: 0, maxPrice: 204000000, score: 1 },
    { min: 27, max: 40, jobIndex: 9, minPrice: 0, maxPrice: 204000000, score: -1 },
    { min: 40, max: 55, jobIndex: 9, minPrice: 0, maxPrice: 204000000, score: -4 },
    { min: 55, max: 200, jobIndex: 9, minPrice: 0, maxPrice: 204000000, score: -4 },

    { min: 0, max: 27, jobIndex: 9, minPrice: 204000000, maxPrice: 800000000, score: 1 },
    { min: 27, max: 40, jobIndex: 9, minPrice: 204000000, maxPrice: 800000000, score: 0 },
    { min: 40, max: 55, jobIndex: 9, minPrice: 204000000, maxPrice: 800000000, score: -2 },
    { min: 55, max: 200, jobIndex: 9, minPrice: 204000000, maxPrice: 800000000, score: -4 },

    { min: 0, max: 27, jobIndex: 9, minPrice: 800000000, maxPrice: 1150000000, score: 1 },
    { min: 27, max: 40, jobIndex: 9, minPrice: 800000000, maxPrice: 1150000000, score: 1 },
    { min: 40, max: 55, jobIndex: 9, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 55, max: 200, jobIndex: 9, minPrice: 800000000, maxPrice: 1150000000, score: 0 },

    { min: 0, max: 27, jobIndex: 9, minPrice: 1150000000, maxPrice: 1500220000, score: 2 },
    { min: 27, max: 40, jobIndex: 9, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 40, max: 55, jobIndex: 9, minPrice: 1150000000, maxPrice: 1500220000, score: 2 },
    { min: 55, max: 200, jobIndex: 9, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },

    { min: 0, max: 27, jobIndex: 9, minPrice: 1500220000, maxPrice: 2200300000, score: 7 },
    { min: 27, max: 40, jobIndex: 9, minPrice: 1500220000, maxPrice: 2200300000, score: 6 },
    { min: 40, max: 55, jobIndex: 9, minPrice: 1500220000, maxPrice: 2200300000, score: 5 },
    { min: 55, max: 200, jobIndex: 9, minPrice: 1500220000, maxPrice: 2200300000, score: 1 },

    { min: 0, max: 27, jobIndex: 9, minPrice: 2200300000, maxPrice: 3000400000, score: 7 },
    { min: 27, max: 40, jobIndex: 9, minPrice: 2200300000, maxPrice: 3000400000, score: 6 },
    { min: 40, max: 55, jobIndex: 9, minPrice: 2200300000, maxPrice: 3000400000, score: 5 },
    { min: 55, max: 200, jobIndex: 9, minPrice: 2200300000, maxPrice: 3000400000, score: 1 },

    { min: 0, max: 27, jobIndex: 9, minPrice: 3000400000, maxPrice: 4000500000, score: 4 },
    { min: 27, max: 40, jobIndex: 9, minPrice: 3000400000, maxPrice: 4000500000, score: 4 },
    { min: 40, max: 55, jobIndex: 9, minPrice: 3000400000, maxPrice: 4000500000, score: 7 },
    { min: 55, max: 200, jobIndex: 9, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },

    { min: 0, max: 27, jobIndex: 9, minPrice: 4000500000, maxPrice: 5000700000, score: 3 },
    { min: 27, max: 40, jobIndex: 9, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 40, max: 55, jobIndex: 9, minPrice: 4000500000, maxPrice: 5000700000, score: 7 },
    { min: 55, max: 200, jobIndex: 9, minPrice: 4000500000, maxPrice: 5000700000, score: 8 },

    { min: 0, max: 27, jobIndex: 9, minPrice: 5000700000, maxPrice: 10000000000, score: 2 },
    { min: 27, max: 40, jobIndex: 9, minPrice: 5000700000, maxPrice: 10000000000, score: 6 },
    { min: 40, max: 55, jobIndex: 9, minPrice: 5000700000, maxPrice: 10000000000, score: 8 },
    { min: 55, max: 200, jobIndex: 9, minPrice: 5000700000, maxPrice: 10000000000, score: 10 },

    // Enginner
    { min: 0, max: 27, jobIndex: 10, minPrice: 0, maxPrice: 204000000, score: -2 },
    { min: 27, max: 40, jobIndex: 10, minPrice: 0, maxPrice: 204000000, score: -3 },
    { min: 40, max: 55, jobIndex: 10, minPrice: 0, maxPrice: 204000000, score: -3 },
    { min: 55, max: 200, jobIndex: 10, minPrice: 0, maxPrice: 204000000, score: -3 },

    { min: 0, max: 27, jobIndex: 10, minPrice: 204000000, maxPrice: 800000000, score: -1 },
    { min: 27, max: 40, jobIndex: 10, minPrice: 204000000, maxPrice: 800000000, score: -3 },
    { min: 40, max: 55, jobIndex: 10, minPrice: 204000000, maxPrice: 800000000, score: -3 },
    { min: 55, max: 200, jobIndex: 10, minPrice: 204000000, maxPrice: 800000000, score: -3 },

    { min: 0, max: 27, jobIndex: 10, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 27, max: 40, jobIndex: 10, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 40, max: 55, jobIndex: 10, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 55, max: 200, jobIndex: 10, minPrice: 800000000, maxPrice: 1150000000, score: -2 },

    { min: 0, max: 27, jobIndex: 10, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 27, max: 40, jobIndex: 10, minPrice: 1150000000, maxPrice: 1500220000, score: 0 },
    { min: 40, max: 55, jobIndex: 10, minPrice: 1150000000, maxPrice: 1500220000, score: -1 },
    { min: 55, max: 200, jobIndex: 10, minPrice: 1150000000, maxPrice: 1500220000, score: -2 },

    { min: 0, max: 27, jobIndex: 10, minPrice: 1500220000, maxPrice: 2200300000, score: 2 },
    { min: 27, max: 40, jobIndex: 10, minPrice: 1500220000, maxPrice: 2200300000, score: 0 },
    { min: 40, max: 55, jobIndex: 10, minPrice: 1500220000, maxPrice: 2200300000, score: -1 },
    { min: 55, max: 200, jobIndex: 10, minPrice: 1500220000, maxPrice: 2200300000, score: -2 },

    { min: 0, max: 27, jobIndex: 10, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 27, max: 40, jobIndex: 10, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },
    { min: 40, max: 55, jobIndex: 10, minPrice: 2200300000, maxPrice: 3000400000, score: 1 },
    { min: 55, max: 200, jobIndex: 10, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },

    { min: 0, max: 27, jobIndex: 10, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 27, max: 40, jobIndex: 10, minPrice: 3000400000, maxPrice: 4000500000, score: 4 },
    { min: 40, max: 55, jobIndex: 10, minPrice: 3000400000, maxPrice: 4000500000, score: 3 },
    { min: 55, max: 200, jobIndex: 10, minPrice: 3000400000, maxPrice: 4000500000, score: 2 },

    { min: 0, max: 27, jobIndex: 10, minPrice: 4000500000, maxPrice: 5000700000, score: 6 },
    { min: 27, max: 40, jobIndex: 10, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 40, max: 55, jobIndex: 10, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 55, max: 200, jobIndex: 10, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },

    { min: 0, max: 27, jobIndex: 10, minPrice: 5000700000, maxPrice: 10000000000, score: 6 },
    { min: 27, max: 40, jobIndex: 10, minPrice: 5000700000, maxPrice: 10000000000, score: 6 },
    { min: 40, max: 55, jobIndex: 10, minPrice: 5000700000, maxPrice: 10000000000, score: 9 },
    { min: 55, max: 200, jobIndex: 10, minPrice: 5000700000, maxPrice: 10000000000, score: 10 },

    // One lic
    { min: 0, max: 27, jobIndex: 11, minPrice: 0, maxPrice: 204000000, score: -2 },
    { min: 27, max: 40, jobIndex: 11, minPrice: 0, maxPrice: 204000000, score: -3 },
    { min: 40, max: 55, jobIndex: 11, minPrice: 0, maxPrice: 204000000, score: -3 },
    { min: 55, max: 200, jobIndex: 11, minPrice: 0, maxPrice: 204000000, score: -3 },

    { min: 0, max: 27, jobIndex: 11, minPrice: 204000000, maxPrice: 800000000, score: -1 },
    { min: 27, max: 40, jobIndex: 11, minPrice: 204000000, maxPrice: 800000000, score: -3 },
    { min: 40, max: 55, jobIndex: 11, minPrice: 204000000, maxPrice: 800000000, score: -3 },
    { min: 55, max: 200, jobIndex: 11, minPrice: 204000000, maxPrice: 800000000, score: -3 },

    { min: 0, max: 27, jobIndex: 11, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 27, max: 40, jobIndex: 11, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 40, max: 55, jobIndex: 11, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 55, max: 200, jobIndex: 11, minPrice: 800000000, maxPrice: 1150000000, score: -2 },

    { min: 0, max: 27, jobIndex: 11, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 27, max: 40, jobIndex: 11, minPrice: 1150000000, maxPrice: 1500220000, score: 0 },
    { min: 40, max: 55, jobIndex: 11, minPrice: 1150000000, maxPrice: 1500220000, score: -1 },
    { min: 55, max: 200, jobIndex: 11, minPrice: 1150000000, maxPrice: 1500220000, score: -2 },

    { min: 0, max: 27, jobIndex: 11, minPrice: 1500220000, maxPrice: 2200300000, score: 2 },
    { min: 27, max: 40, jobIndex: 11, minPrice: 1500220000, maxPrice: 2200300000, score: 0 },
    { min: 40, max: 55, jobIndex: 11, minPrice: 1500220000, maxPrice: 2200300000, score: -1 },
    { min: 55, max: 200, jobIndex: 11, minPrice: 1500220000, maxPrice: 2200300000, score: -2 },

    { min: 0, max: 27, jobIndex: 11, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 27, max: 40, jobIndex: 11, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },
    { min: 40, max: 55, jobIndex: 11, minPrice: 2200300000, maxPrice: 3000400000, score: 1 },
    { min: 55, max: 200, jobIndex: 11, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },

    { min: 0, max: 27, jobIndex: 11, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 27, max: 40, jobIndex: 11, minPrice: 3000400000, maxPrice: 4000500000, score: 4 },
    { min: 40, max: 55, jobIndex: 11, minPrice: 3000400000, maxPrice: 4000500000, score: 3 },
    { min: 55, max: 200, jobIndex: 11, minPrice: 3000400000, maxPrice: 4000500000, score: 2 },

    { min: 0, max: 27, jobIndex: 11, minPrice: 4000500000, maxPrice: 5000700000, score: 6 },
    { min: 27, max: 40, jobIndex: 11, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 40, max: 55, jobIndex: 11, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 55, max: 200, jobIndex: 11, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },

    { min: 0, max: 27, jobIndex: 11, minPrice: 5000700000, maxPrice: 10000000000, score: 6 },
    { min: 27, max: 40, jobIndex: 11, minPrice: 5000700000, maxPrice: 10000000000, score: 6 },
    { min: 40, max: 55, jobIndex: 11, minPrice: 5000700000, maxPrice: 10000000000, score: 9 },
    { min: 55, max: 200, jobIndex: 11, minPrice: 5000700000, maxPrice: 10000000000, score: 10 },

    // Two lic
    { min: 0, max: 27, jobIndex: 12, minPrice: 0, maxPrice: 204000000, score: -1 },
    { min: 27, max: 40, jobIndex: 12, minPrice: 0, maxPrice: 204000000, score: -2 },
    { min: 40, max: 55, jobIndex: 12, minPrice: 0, maxPrice: 204000000, score: -3 },
    { min: 55, max: 200, jobIndex: 12, minPrice: 0, maxPrice: 204000000, score: -3 },

    { min: 0, max: 27, jobIndex: 12, minPrice: 204000000, maxPrice: 800000000, score: 0 },
    { min: 27, max: 40, jobIndex: 12, minPrice: 204000000, maxPrice: 800000000, score: -1 },
    { min: 40, max: 55, jobIndex: 12, minPrice: 204000000, maxPrice: 800000000, score: -3 },
    { min: 55, max: 200, jobIndex: 12, minPrice: 204000000, maxPrice: 800000000, score: -3 },

    { min: 0, max: 27, jobIndex: 12, minPrice: 800000000, maxPrice: 1150000000, score: 2 },
    { min: 27, max: 40, jobIndex: 12, minPrice: 800000000, maxPrice: 1150000000, score: -1 },
    { min: 40, max: 55, jobIndex: 12, minPrice: 800000000, maxPrice: 1150000000, score: -2 },
    { min: 55, max: 200, jobIndex: 12, minPrice: 800000000, maxPrice: 1150000000, score: -3 },

    { min: 0, max: 27, jobIndex: 12, minPrice: 1150000000, maxPrice: 1500220000, score: 3 },
    { min: 27, max: 40, jobIndex: 12, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 40, max: 55, jobIndex: 12, minPrice: 1150000000, maxPrice: 1500220000, score: 1 },
    { min: 55, max: 200, jobIndex: 12, minPrice: 1150000000, maxPrice: 1500220000, score: -2 },

    { min: 0, max: 27, jobIndex: 12, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },
    { min: 27, max: 40, jobIndex: 12, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },
    { min: 40, max: 55, jobIndex: 12, minPrice: 1500220000, maxPrice: 2200300000, score: 1 },
    { min: 55, max: 200, jobIndex: 12, minPrice: 1500220000, maxPrice: 2200300000, score: 0 },

    { min: 0, max: 27, jobIndex: 12, minPrice: 2200300000, maxPrice: 3000400000, score: 5 },
    { min: 27, max: 40, jobIndex: 12, minPrice: 2200300000, maxPrice: 3000400000, score: 4 },
    { min: 40, max: 55, jobIndex: 12, minPrice: 2200300000, maxPrice: 3000400000, score: 3 },
    { min: 55, max: 200, jobIndex: 12, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },

    { min: 0, max: 27, jobIndex: 12, minPrice: 3000400000, maxPrice: 4000500000, score: 7 },
    { min: 27, max: 40, jobIndex: 12, minPrice: 3000400000, maxPrice: 4000500000, score: 4 },
    { min: 40, max: 55, jobIndex: 12, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 55, max: 200, jobIndex: 12, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },

    { min: 0, max: 27, jobIndex: 12, minPrice: 4000500000, maxPrice: 5000700000, score: 7 },
    { min: 27, max: 40, jobIndex: 12, minPrice: 4000500000, maxPrice: 5000700000, score: 6 },
    { min: 40, max: 55, jobIndex: 12, minPrice: 4000500000, maxPrice: 5000700000, score: 6 },
    { min: 55, max: 200, jobIndex: 12, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },

    { min: 0, max: 27, jobIndex: 12, minPrice: 5000700000, maxPrice: 10000000000, score: 4 },
    { min: 27, max: 40, jobIndex: 12, minPrice: 5000700000, maxPrice: 10000000000, score: 7 },
    { min: 40, max: 55, jobIndex: 12, minPrice: 5000700000, maxPrice: 10000000000, score: 8 },
    { min: 55, max: 200, jobIndex: 12, minPrice: 5000700000, maxPrice: 10000000000, score: 10 },

    // Three lic
    { min: 0, max: 27, jobIndex: 13, minPrice: 0, maxPrice: 204000000, score: 0 },
    { min: 27, max: 40, jobIndex: 13, minPrice: 0, maxPrice: 204000000, score: -1 },
    { min: 40, max: 55, jobIndex: 13, minPrice: 0, maxPrice: 204000000, score: -2 },
    { min: 55, max: 200, jobIndex: 13, minPrice: 0, maxPrice: 204000000, score: -3 },

    { min: 0, max: 27, jobIndex: 13, minPrice: 204000000, maxPrice: 800000000, score: 0 },
    { min: 27, max: 40, jobIndex: 13, minPrice: 204000000, maxPrice: 800000000, score: 0 },
    { min: 40, max: 55, jobIndex: 13, minPrice: 204000000, maxPrice: 800000000, score: -2 },
    { min: 55, max: 200, jobIndex: 13, minPrice: 204000000, maxPrice: 800000000, score: -3 },

    { min: 0, max: 27, jobIndex: 13, minPrice: 800000000, maxPrice: 1150000000, score: 2 },
    { min: 27, max: 40, jobIndex: 13, minPrice: 800000000, maxPrice: 1150000000, score: 1 },
    { min: 40, max: 55, jobIndex: 13, minPrice: 800000000, maxPrice: 1150000000, score: 0 },
    { min: 55, max: 200, jobIndex: 13, minPrice: 800000000, maxPrice: 1150000000, score: 0 },

    { min: 0, max: 27, jobIndex: 13, minPrice: 1150000000, maxPrice: 1500220000, score: 4 },
    { min: 27, max: 40, jobIndex: 13, minPrice: 1150000000, maxPrice: 1500220000, score: 2 },
    { min: 40, max: 55, jobIndex: 13, minPrice: 1150000000, maxPrice: 1500220000, score: 0 },
    { min: 55, max: 200, jobIndex: 13, minPrice: 1150000000, maxPrice: 1500220000, score: 0 },

    { min: 0, max: 27, jobIndex: 13, minPrice: 1500220000, maxPrice: 2200300000, score: 5 },
    { min: 27, max: 40, jobIndex: 13, minPrice: 1500220000, maxPrice: 2200300000, score: 3 },
    { min: 40, max: 55, jobIndex: 13, minPrice: 1500220000, maxPrice: 2200300000, score: 1 },
    { min: 55, max: 200, jobIndex: 13, minPrice: 1500220000, maxPrice: 2200300000, score: 1 },

    { min: 0, max: 27, jobIndex: 13, minPrice: 2200300000, maxPrice: 3000400000, score: 5 },
    { min: 27, max: 40, jobIndex: 13, minPrice: 2200300000, maxPrice: 3000400000, score: 4 },
    { min: 40, max: 55, jobIndex: 13, minPrice: 2200300000, maxPrice: 3000400000, score: 2 },
    { min: 55, max: 200, jobIndex: 13, minPrice: 2200300000, maxPrice: 3000400000, score: 1 },

    { min: 0, max: 27, jobIndex: 13, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 27, max: 40, jobIndex: 13, minPrice: 3000400000, maxPrice: 4000500000, score: 5 },
    { min: 40, max: 55, jobIndex: 13, minPrice: 3000400000, maxPrice: 4000500000, score: 4 },
    { min: 55, max: 200, jobIndex: 13, minPrice: 3000400000, maxPrice: 4000500000, score: 3 },

    { min: 0, max: 27, jobIndex: 13, minPrice: 4000500000, maxPrice: 5000700000, score: 3 },
    { min: 27, max: 40, jobIndex: 13, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 40, max: 55, jobIndex: 13, minPrice: 4000500000, maxPrice: 5000700000, score: 5 },
    { min: 55, max: 200, jobIndex: 13, minPrice: 4000500000, maxPrice: 5000700000, score: 6 },

    { min: 0, max: 27, jobIndex: 13, minPrice: 5000700000, maxPrice: 10000000000, score: -4 },
    { min: 27, max: 40, jobIndex: 13, minPrice: 5000700000, maxPrice: 10000000000, score: 0 },
    { min: 40, max: 55, jobIndex: 13, minPrice: 5000700000, maxPrice: 10000000000, score: 2 },
    { min: 55, max: 200, jobIndex: 13, minPrice: 5000700000, maxPrice: 10000000000, score: 8 }
];

export default bankAccountBalanceScores;
